module.exports = __webpack_public_path__ + "img/carrgo-team.34ddc2e3.jpg";